export const DEFAULT_LANG = 'fr';
export const TABLET_WIDTH = 1024;
export const SMALL_DESKTOP_WIDTH = 1360;
